import { render, staticRenderFns } from "./TheFailedEgiftSendsPanel.vue?vue&type=template&id=28b5b43a&scoped=true"
import script from "./TheFailedEgiftSendsPanel.vue?vue&type=script&lang=js"
export * from "./TheFailedEgiftSendsPanel.vue?vue&type=script&lang=js"
import style0 from "./TheFailedEgiftSendsPanel.vue?vue&type=style&index=0&id=28b5b43a&prod&lang=scss"
import style1 from "./TheFailedEgiftSendsPanel.vue?vue&type=style&index=1&id=28b5b43a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b5b43a",
  null
  
)

export default component.exports